import { useUserStore } from "@/stores";
import styles from "./index.module.scss";
import clsx from "clsx";
import { GenerateSvg, GeneratingSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { SCENE_ID, LocalStorageKey, PageType } from "@/constants";
import { credits_png } from "@/assets/images";
import EventHub from "@/utils/event";
import { GlobalEvent } from "@/constants/event";
import Analyse from "@/utils/analyse";
import useEffectStore from "@/stores/effectStore";

interface GenerateButtonProps {
  className?: string;
  beforeClick?: () => boolean;
  startGenerate?: () => void;
}

const GenerateButton = (props: GenerateButtonProps) => {
  const { className } = props;
  const { t } = useTranslation();
  const generating = useEffectStore((state) => state.generating);
  const creditConsume = 1;
  const disabledGenerate = useEffectStore(
    (state) => state.getters.disabledGenerate
  );
  const isLogin = useUserStore((state) => state.getters.isLogin);
  const submitTask = useEffectStore((state) => state.submitTask);
  const loopTask = useEffectStore((state) => state.loopTask);
  const fetchCredits = useUserStore((state) => state.fetchCredits);
  const showPayment = useUserStore((state) => state.showPayment);
  const showLogin = useUserStore((state) => state.showLogin);
  const fetchVipStatus = useUserStore((state) => state.fetchVipStatus);
  const setGenerating = useEffectStore((state) => state.setGenerating);
  const receiveCredits = useUserStore((state) => state.receiveCredits);

  const handleClick = async () => {
    if (props.beforeClick) {
      const result = props.beforeClick();
      if (!result) {
        return;
      }
    }
    if (generating) {
      toast(t("generating"));
      return;
    }
    setGenerating(true);
    let payType: "free" | "credits" = "free";
    if (!localStorage.getItem(LocalStorageKey.userInfo)) {
      await useUserStore.getState().refreshFreeCount();
      let remainNums = useUserStore.getState().remainNums;
      let count = remainNums;
      if (count <= 0) {
        payType = "credits"
        try {
          await showLogin({
            isSignIn: true,
            options: {
              position: "figure_generate",
            },
            isShowScenses: true,
            otherParam: {
              scenesId: SCENE_ID,
            },
          });
          await receiveCredits();
          const credits = await fetchCredits();
          payType = "credits"
          if (credits < creditConsume) {
            await fetchVipStatus();
            try {
              await showPayment({
                position: "figure_generate",
                otherParam: {
                  scenesId: SCENE_ID,
                },
              });
            } catch (err) {
              console.error(err);
              Analyse.getInstance().clickUpGenerate("no_credits");
              // 埋点（积分不足）
              setGenerating(false);
              return;
            }
          }

        } catch (err) {
          console.error(err);
          Analyse.getInstance().clickUpGenerate("no_login");
          setGenerating(false);
          return;
        }
      } else {
        payType = "free";
      }
    } else {
      payType = "credits"
      try {
        const isLogin = await useUserStore.getState().fetchUserInfo();
        if (!isLogin) {
          localStorage.removeItem(LocalStorageKey.userInfo);
          handleClick();
          return;
        }
        payType = "credits"
        const credits = await fetchCredits();
        if (credits < creditConsume) {
          await fetchVipStatus();

          try {
            await showPayment({
              position: "figure_generate",
              otherParam: {
                scenesId: SCENE_ID,
              },
            });
          } catch (err) {
            console.error(err);
            Analyse.getInstance().clickUpGenerate("no_credits");
            setGenerating(false);

            return;
          }
        } else {
          payType = "credits";
        }
      } catch (error) {
        console.error(error);
      }
    }
    Analyse.getInstance().clickUpGenerate("start");
    try {
      props.startGenerate?.();
      await submitTask(payType);
    } catch (err) {
      console.error(err);
      const pageType = useEffectStore.getState().pageType;
      if (pageType !== PageType.Failed) {
        if (err instanceof Error) {
          const name = err.name;
          if (["101", "102", "513", "515"].includes(name)) {
            toast.error(t(err.message));
          } else {
            toast.error(t("error_server"));
          }
        } else {
          toast.error(t("error_server"));
        }
      }

      setGenerating(false);
      EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
      return;
    }
    const task = useEffectStore.getState().task;
    if (task) {
      EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
      await loopTask();
      // showRemoveTip();
      const isLogin = useUserStore.getState().getters.isLogin;
      if (!isLogin) {
        useUserStore.getState().refreshFreeCount();
      }
    }
  };
  return (
    <button
      className={clsx(
        styles["generate_button"],
        // generating && styles["generating"],
        className
      )}
      disabled={disabledGenerate}
      onClick={handleClick}
    >
      {generating ? (
        <GeneratingSvg className={styles.generating_svg}></GeneratingSvg>
      ) : (
        <GenerateSvg></GenerateSvg>
      )}

      <span className={styles["text"]}>
        {generating ? t("generating") : t("generate_btn")}
      </span>

      {creditConsume > 0 && !disabledGenerate && isLogin && !generating && (
        <span className={styles["credits_wrapper"]}>
          <img className={styles["credits_img"]} src={credits_png} alt="" />
          <span className={styles["credits"]}>{creditConsume}</span>
        </span>
      )}
    </button>
  );
};

export default GenerateButton;
